import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import NOIBox from "./NOIBox";

import { noiIncreaseData } from "../../sample";
import { noiEndPoints } from "../../../../services/apiEndPoints";
import { currencyFormatter } from "../../../../services/utils";
import { getData } from "../../../../services/api";

const NoiIncrease = ({ filtervalue, handleChange, value }) => {
  const [noiIncrease, setNoiIncrease] = useState(noiIncreaseData);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  useEffect(() => {
    const dateQueryParams = {
      period,
      startDate,
      endDate,
    };
    if (filtervalue) {
      getData(
        noiEndPoints.NOI_INCREASE,
        (data) => {
          setNoiIncreasePowerRevenue(data, filtervalue);
        },
        { existing_noi: parseInt(filtervalue * 1000000), ...dateQueryParams }
      );
    }
  }, [period, startDate, endDate, filtervalue]);

  const setNoiIncreasePowerRevenue = (noiIncreasePR, exitingParameter) => {
    setNoiIncrease((prevState) => {
      return {
        ...prevState,
        rows: prevState.rows.map((val) => {
          if (!noiIncreasePR[val.key] && noiIncreasePR[val.key] !== 0)
            return { ...val, value: exitingParameter };
          return {
            ...val,
            value:
              val.key !== "noi_increase"
                ? currencyFormatter(noiIncreasePR[val.key], currencySymbol)
                : `${noiIncreasePR[val.key].toFixed(1).toString().replace(/\.0$/, "")}%`,
          };
        }),
        chartData: {
          ...prevState.chartData,
          data: prevState.chartData.data.map(() => {
            return {
              power_revenue_NOI: noiIncreasePR.power_revenue_noi,
              existing_NOI: exitingParameter * 1000000,
            };
          }),
        },
      };
    });
  };

  return <NOIBox item={noiIncrease} filtervalue={value} handleChange={handleChange} />;
};
export default NoiIncrease;
